import { useSurvey } from '../SurveyContext';

export function ScaleStep() {
  const surveyFlow = useSurvey();
  const v = typeof surveyFlow.answers.gpa === 'number' ? surveyFlow.answers.gpa : 2.0;
  return (
    <>
      <div className="intake-gpa-read">
        {v.toFixed(2)}
        <small> / 4.00</small>
      </div>
      <input
        className="intake-slider"
        type="range"
        min={0}
        max={4}
        step={0.01}
        value={v}
        onChange={(e) => surveyFlow.setGpa(parseFloat(e.target.value))}
      />
    </>
  );
}
